import React from 'react'
import { Link, useParams } from 'react-router-dom'

import ShapeTwo from '../../components/shape-two'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'

import {FiAirplay, FiMapPin, FiArrowRight, VscSend, FiUserCheck, FiMonitor, FiBriefcase,FiBook, FiDollarSign, FiClock} from '../../assets/icons/vander'

import { jobData, jobDuties, jobSkill } from '../../data/job'

export default function PageJobDetail() {
  let params = useParams()
  let id = params.id;
  let data = jobData.find((job) => job.id === parseInt(id))

  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">{data?.title ? data?.title : 'Web Designer'}</h4>
                          <ul className="mt-3 list-unstyled">
                              <li className="list-inline-item text-muted me-1"><FiAirplay className="align-middle text-primary h6 mb-0"/> <Link to="https://1.envato.market/leaping" target="_blank" className="text-muted">{data?.name ? data?.name : 'leaping pvt. ltd.'}</Link></li>
                              <li className="list-inline-item text-muted"><FiMapPin className="align-middle text-primary h6 mb-0"/> {data?.country ? data?.country :'India'}</li>
                          </ul>
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Job Detail</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-5 col-12">
                  <div className="card sidebar sticky-bar rounded shadow border-0">
                      <div className="card-body widget border-bottom">
                          <h5 className="mb-0">Job Information</h5>
                      </div>

                      <div className="card-body">
                          <div className="d-flex widget align-items-center">
                              <FiUserCheck className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Employee Type:</h4>
                                  <p className="text-primary mb-0">{data?.jobType ? data?.jobType : 'Full Time'}</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiMapPin className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Location:</h4>
                                  <p className="text-primary mb-0">{data?.country ? data?.country :'India'}</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiMonitor className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Job Type:</h4>
                                  <p className="text-primary mb-0">{data?.title ? data?.title : 'Web Designer'}</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiBriefcase className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Experience:</h4>
                                  <p className="text-primary mb-0">+2 Year</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiBook className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Qualifications:</h4>
                                  <p className="text-primary mb-0">MSCIT</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiDollarSign className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Salary:</h4>
                                  <p className="text-primary mb-0">+50k to 70k</p>
                              </div>
                          </div>

                          <div className="d-flex widget align-items-center mt-3">
                              <FiClock className="fea icon-ex-md me-3"/>
                              <div className="flex-1">
                                  <h4 className="widget-title mb-0">Date posted:</h4>
                                  <p className="text-primary mb-0 mb-0">19th June, 2024</p>
                              </div>
                          </div>

                      </div>
                  </div>
              </div>

              <div className="col-lg-8 col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="ms-lg-4">
                      <h5>Job Description: </h5>
                      <p className="text-muted">One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others - which creates a distinct visual impression. Moreover, in Latin only words at the beginning of sentences are capitalized.</p>
                      <p className="text-muted">This means that Lorem Ipsum cannot accurately represent, for example, German, in which all nouns are capitalized. Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts. If the fill text is intended to illustrate the characteristics of different typefaces.</p>
                      <p className="text-muted">It sometimes makes sense to select texts containing the various letters and symbols specific to the output language.</p>
                      
                      <h5 className="mt-4">Responsibilities and Duties: </h5>
                      <p className="text-muted">It sometimes makes sense to select texts containing the various letters and symbols specific to the output language.</p>
                      <ul className="list-unstyled">
                        {jobDuties.map((item,index)=>{
                          return(
                            <li className="text-muted mt-2" key={index}><FiArrowRight className="fea icon-sm text-success me-2"/>{item}</li>
                          )
                        })}
                      </ul>

                      <h5 className="mt-4">Required Experience, Skills and Qualifications: </h5>
                      <p className="text-muted">It sometimes makes sense to select texts containing the various letters and symbols specific to the output language.</p>
                      <ul className="list-unstyled">
                        {jobSkill.map((item,index)=>{
                          return(
                            <li className="text-muted mt-2" key={index}><FiArrowRight className="fea icon-sm text-success me-2"/>{item}</li>
                          )
                        })}
                      </ul>

                      <div className="mt-4">
                          <Link to="/page-job-apply-form" className="btn btn-outline-primary">Apply Now <VscSend className=""/></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-end mb-4 pb-2">
              <div className="col-md-8">
                  <div className="section-title text-center text-md-start">
                      <h4 className="title mb-4">Related Jobs</h4>
                      <p className="text-muted mb-0 para-desc">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>

              <div className="col-md-4 mt-4 mt-sm-0 d-none d-md-block">
                  <div className="text-center text-md-end">
                      <Link to="/page-jobs" className="text-primary">View more Jobs <FiArrowRight className="fea icon-sm"/></Link>
                  </div>
              </div>
          </div>

          <div className="row">   
            {jobData.slice(0,3).map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="card border-0 bg-light rounded shadow">
                          <div className="card-body p-4">
                              <span className="badge rounded-pill bg-primary float-md-end mb-3 mb-sm-0">{item.jobType}</span>
                              <h5>{item.title}</h5>
                              <div className="mt-3">
                                  <span className="text-muted d-block"><FiAirplay className="text-primary h6 mb-0"/> <Link to="https://1.envato.market/hostick-template" target="_blank" className="text-muted">{item.name}</Link></span>
                                  <span className="text-muted d-block"><FiMapPin className="text-primary h6 mb-0"/> {item.country}</span>
                              </div>
                              
                              <div className="mt-3">
                                  <Link to="/page-job-detail" className="btn btn-primary">View Details</Link>
                              </div>
                          </div>
                      </div>
                  </div>
              )
            })}                 
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
